import { JUSTICE_REQUEST_CATEGORY } from '@/constants/bookingRequest';

export const TEXT_FOR_JUSTICE_PROCEDURE_TYPE = {
  [JUSTICE_REQUEST_CATEGORY.NO.id]: 'Pas de procédure',
  [JUSTICE_REQUEST_CATEGORY.YES.id]: 'Avec procédure',
};
